import { locationRestConsentPost } from "../wp-api";
import { getOptionsFromWindow } from "../utils";
import { applyConsentForwarding, getCookieConsentManager } from ".";
import { commonRequest } from "@devowl-wp/utils";
import { yieldMainThread } from "@devowl-wp/react-utils";

/**
 * Save consent to the backend and apply cookies on running session.
 */
const applyConsent = async _ref => {
  let {
    consent,
    gcmConsent,
    markAsDoNotTrack = false,
    buttonClicked,
    blocker = 0,
    blockerThumbnail,
    tcfString,
    recorderJsonString,
    uiView
  } = _ref;
  const {
    clientWidth,
    clientHeight
  } = document.documentElement;
  const {
    restNamespace,
    restRoot,
    restQuery,
    restNonce,
    restPathObfuscateOffset
  } = getOptionsFromWindow();
  let awaitedTcfString;
  if (tcfString) {
    awaitedTcfString = tcfString();
    await yieldMainThread();
  }

  // Use `commonRequest` cause on frontend we do not have `wp.i18n` available
  const {
    forward,
    uuid,
    revisionHash,
    decision
  } = await commonRequest({
    location: locationRestConsentPost,
    options: {
      restNamespace,
      restRoot,
      restQuery,
      restNonce,
      restPathObfuscateOffset
    },
    sendRestNonce: false,
    request: {
      decision: consent,
      gcmConsent,
      markAsDoNotTrack,
      buttonClicked,
      viewPortWidth: clientWidth,
      viewPortHeight: clientHeight,
      blocker,
      blockerThumbnail,
      tcfString: awaitedTcfString,
      recorderJsonString,
      uiView
    },
    params: {
      _wp_http_referer: window.location.href
    }
  });

  // Does the browser support cookies? Save the decision locally in `window` so `getUserDecision` can fallback
  window.rcbDisabledCookieComp = {
    uuid,
    previousUuids: [],
    revision: revisionHash,
    consent: decision
  };
  await Promise.all([
  // Apply consent forwarding and wait for all requests
  forward && applyConsentForwarding(forward), getCookieConsentManager().applyCookies({
    type: "consent"
  })].filter(Boolean));
};
export { applyConsent };